// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"transitionVairant_paragraph__3AoO7","highlight":"transitionVairant_highlight__2M-q1","btn":"transitionVairant_btn__1k2cq"};